import { BaseSearchDTO } from "../../../../../uinspect/src/app/global/interfaces";

export interface UInspectMediaSearchDTO extends BaseSearchDTO {
  filters?: {
    id: number,
  };
}
